import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, VNode } from 'intact-vue-next';
import template from './index.vdt';
export * from './column';
import { useConfigContext } from '../config';
var typeDefs = {
  title: [String, VNode],
  type: ['shadow', 'border', 'none'],
  size: String
};
var defaults = function defaults() {
  return {
    type: 'shadow',
    size: 'default'
  };
};
export var Card = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Card, _Component);
  function Card() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return Card;
}(Component);
Card.template = template;
Card.typeDefs = typeDefs;
Card.defaults = defaults;